import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { User, Organization } from '@awang/shared-types'
import * as identityApi from '@/api/identity'

export const useAdminStore = defineStore('admin', () => {
  const user = ref<User | null>(null)
  const org = ref<Organization | null>(null)
  const isLoggedIn = computed(() => !!user.value)

  function setTokens(accessToken: string, refreshToken: string): void {
    localStorage.setItem('admin_access_token', accessToken)
    localStorage.setItem('admin_refresh_token', refreshToken)
  }

  function clearTokens(): void {
    localStorage.removeItem('admin_access_token')
    localStorage.removeItem('admin_refresh_token')
  }

  async function login(email: string, password: string): Promise<void> {
    const res = await identityApi.login({ email, password })
    user.value = res.user
    org.value = res.organization
    setTokens(res.access_token, res.refresh_token)
  }

  async function fetchMe(): Promise<void> {
    const me = await identityApi.getMe()
    user.value = me
  }

  async function logout(): Promise<void> {
    const refreshToken = localStorage.getItem('admin_refresh_token')
    if (refreshToken) {
      try {
        await identityApi.logout(refreshToken)
      } catch {
        // 即使后端注销失败，也继续清理本地状态
      }
    }
    user.value = null
    org.value = null
    clearTokens()
  }

  return { user, org, isLoggedIn, login, fetchMe, logout }
})
